import { jsx as m, jsxs as x } from "react/jsx-runtime";
function g(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var l = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var p;
function y() {
  return p || (p = 1, function(e) {
    (function() {
      var s = {}.hasOwnProperty;
      function n() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var o = arguments[t];
          o && (r = u(r, i.call(this, o)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var o in r)
          s.call(r, o) && r[o] && (t = u(t, this && this[o] || o));
        return t;
      }
      function u(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(l)), l.exports;
}
var h = y();
const w = /* @__PURE__ */ g(h), j = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, S = w.bind(j), c = "purpur-icon", b = "md", O = (e) => e.filter((s) => Object.keys(s).length >= 1).map((s) => `${s.name}="${s.value}"`).join(" "), $ = ({ content: e = "", title: s } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    s ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], i = s ? `<title>${s}</title>` : "";
  return `<svg ${O(n)}>${i}${e}</svg>`;
}, q = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), _ = ({
  ["data-testid"]: e,
  svg: s,
  allyTitle: n,
  className: i,
  size: u = b,
  ...r
}) => {
  const t = $({
    content: q(s.svg),
    title: n
  }), o = S(i, c, `${c}--${u}`);
  return /* @__PURE__ */ m(
    "span",
    {
      className: o,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
_.displayName = "Icon";
const N = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function C(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var a = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var f;
function A() {
  return f || (f = 1, function(e) {
    (function() {
      var s = {}.hasOwnProperty;
      function n() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var o = arguments[t];
          o && (r = u(r, i(o)));
        }
        return r;
      }
      function i(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var o in r)
          s.call(r, o) && r[o] && (t = u(t, o));
        return t;
      }
      function u(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(a)), a.exports;
}
var M = A();
const P = /* @__PURE__ */ C(M), d = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, T = [
  "additions text",
  "additions",
  "removals",
  "text",
  "all"
], v = "purpur-field-error-text", Z = ({
  children: e,
  className: s,
  ["aria-relevant"]: n = "additions text",
  ...i
}) => /* @__PURE__ */ x(
  "div",
  {
    className: P([s, d[v]]),
    "aria-live": "assertive",
    "aria-relevant": n,
    ...i,
    children: [
      /* @__PURE__ */ m(_, { svg: N, size: "xs", className: d[`${v}__icon`] }),
      e
    ]
  }
);
export {
  Z as FieldErrorText,
  T as ariaRelevantValues
};
//# sourceMappingURL=field-error-text.es.js.map
